import Vue from 'vue'
import { URL_ORGANIZATION_DRAFTS } from '@/constants/urls.js'
import {
  ORGANIZATION_DRAFTS_MANAGEMENT, ERRORS, AXIOS_REQUESTS,
  GENERAL_FILES
} from '@/constants/store.js'

const state = {
  [ORGANIZATION_DRAFTS_MANAGEMENT.STATE.DRAFT_CHANGED]: true,
  [ORGANIZATION_DRAFTS_MANAGEMENT.STATE.DRAFT]: {
    organizationId: null,
    organizationShortName: null,
    organizationFullName: null,
    participantType: null,
    registrationDate: null,
    country: null,
    managerFIO: null,
    managerPosition: null,
    inn: null,
    kpp: null,
    ogrn: null,
    // postAddress: null,
    // realAddress: null,
    location: null,
    email: null,
    phone: null,
    contactPerson: null,
    contactPersonPosition: null
  },
  [ORGANIZATION_DRAFTS_MANAGEMENT.STATE.REQUEST]: null
}

const actions = {
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.MERGE_FIELDS] ({ commit }, draft) {
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.MERGE_FIELDS, draft)
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.DRAFT_CHANGED, true)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.GET_ORGANIZATION_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFTS}/${model.organizationId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.MERGE_FIELDS, resp.data)
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.DRAFT_CHANGED, false)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.CREATE_ORGANIZATION_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFTS}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.MERGE_FIELDS, resp.data)
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.DRAFT_CHANGED, false)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.UPDATE_ORGANIZATION_DRAFT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFTS}/${model.organizationId}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.MERGE_FIELDS, resp.data)
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.DRAFT_CHANGED, false)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.SEND_ORGANIZATION_REGISTRATION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFTS}/${model.organizationId}/request`,
      model: []
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUEST, resp.data)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.GET_ORGANIZATION_REGISTRATION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFTS}/${model.organizationId}/request?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUEST, resp.data)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.GET_REGISTRATION_CARD] ({ commit, dispatch }, model) {
    const url = `${Vue.getIdentityHost()}${URL_ORGANIZATION_DRAFTS}/${model.organizationId}/registrationCard?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_DRAFT] ({ commit }) {
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_DRAFT)
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.DRAFT_CHANGED, true)
  },
  async [ORGANIZATION_DRAFTS_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST] ({ commit }) {
    commit(ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST)
  }
}

const mutations = {
  [ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.DRAFT_CHANGED] (state, flag) {
    state[ORGANIZATION_DRAFTS_MANAGEMENT.STATE.DRAFT_CHANGED] = flag
  },
  [ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.MERGE_FIELDS] (state, editedFieldsObj) {
    for (const key in editedFieldsObj) {
      Vue.set(state[ORGANIZATION_DRAFTS_MANAGEMENT.STATE.DRAFT], key, editedFieldsObj[key])
    }
  },
  [ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_DRAFT] (state) {
    for (const key in state[ORGANIZATION_DRAFTS_MANAGEMENT.STATE.DRAFT]) {
      state[ORGANIZATION_DRAFTS_MANAGEMENT.STATE.DRAFT][key] = null
    }
  },
  [ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUEST] (state, request) {
    state[ORGANIZATION_DRAFTS_MANAGEMENT.STATE.REQUEST] = request
  },
  [ORGANIZATION_DRAFTS_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST] (state) {
    state[ORGANIZATION_DRAFTS_MANAGEMENT.STATE.REQUEST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
